export default {
  Municipios: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "municipios"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Municipios.js
// module id = REZF
// module chunks = 18